import { Button, ButtonType } from "components/Button/Button";
import { formatDate } from "utils/formatting";
import './CourseEditControls.scss';

const CourseEditControls = ({ locked, data, handleLockToggle, canPreview, handlePreviewCourseClick }) => {
	return (
		<>
			<div className="course-editor-controls">
				<h1>Course Controls</h1>
				{locked.hasTimestamp ? (
					locked.byCurrentUser ? (
						<p>
							You have locked this course for editing. To allow other users to
							edit the course please unlock using the button below.
						</p>
					) : (
						<p>
							Course locked by {data.LockUsername} at{" "}
							{formatDate(data.LockTimestamp, true)}
						</p>
					)
				) : (
					<p>Courses must be locked to be editable.</p>
				)}
				<div className="course-editor-controls-buttons">
					<Button
						text={locked.hasTimestamp ? "Unlock" : "Lock for Editing"}
						disabled={locked.hasTimestamp && !locked.byCurrentUser}
						onClick={handleLockToggle}
					/>

					<Button
						type={ButtonType.Secondary}
						text="Preview"
						onClick={handlePreviewCourseClick}
						disabled={!canPreview} />
				</div>
			</div>

		</>
	);
};

export default CourseEditControls;
